// Pain subsection questionnaire constants
export enum PainQuestionnaireItem {
  MEDICAL_BACKGROUND_PAIN = 'medical-background/pain',
  MEDICAL_BACKGROUND_PAIN_STATUS = 'medical-background/pain/status',
  MEDICAL_BACKGROUND_PAIN_GOAL = 'medical-background/pain/goal',
  MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_FACE = 'medical-background/pain/flacc-scale-face',
  MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_LEGS = 'medical-background/pain/flacc-scale-legs',
  MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_ACTIVITY = 'medical-background/pain/flacc-scale-activity',
  MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_CRY = 'medical-background/pain/flacc-scale-cry',
  MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_CONSOLABILITY = 'medical-background/pain/flacc-scale-consolability',
  MEDICAL_BACKGROUND_PAIN_SYSTEM_SUMMARY = 'medical-background/pain/system-summary'
}
